module.exports = __webpack_public_path__ + "img/5E423A_8C6E69_382416_745D64-256px.4c48d294.png";